import * as z from 'zod';

export const AppConfigSchema = z.object({
  isLocal: z.stringbool().default(false),

  version: z.string().nonempty(),
  buildTimestamp: z.string().nonempty(),
});

export type AppConfig = z.infer<typeof AppConfigSchema>;
